function cov_gs7je0sul() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/SlidersFilled.tsx";
  var hash = "5f10803f1227be1957716f41e8ec55e5137bd043";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/SlidersFilled.tsx",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 54
        },
        end: {
          line: 6,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "5f10803f1227be1957716f41e8ec55e5137bd043"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_gs7je0sul = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_gs7je0sul();
var Icon = (cov_gs7je0sul().s[0]++, {
  name: 'sliders-filled',
  svg: "<path d=\"M3.99908 7.25H3C2.30964 7.25 1.75 6.69036 1.75 6C1.75 5.30964 2.30964 4.75 3 4.75H3.99908C4.48886 3.57552 5.64803 2.75 7 2.75C8.35198 2.75 9.51114 3.57552 10.0009 4.75L21 4.75C21.6904 4.75 22.25 5.30964 22.25 6C22.25 6.69036 21.6904 7.25 21 7.25L10.0009 7.25C9.51114 8.42448 8.35197 9.25 7 9.25C5.64803 9.25 4.48886 8.42448 3.99908 7.25Z\" fill=\"currentColor\"/>\n  <path d=\"M21 13.25C21.6904 13.25 22.25 12.6904 22.25 12C22.25 11.3096 21.6904 10.75 21 10.75H19.0009C18.5111 9.57552 17.352 8.75 16 8.75C14.648 8.75 13.4889 9.57552 12.9991 10.75H3C2.30964 10.75 1.75 11.3096 1.75 12C1.75 12.6904 2.30964 13.25 3 13.25H12.9991C13.4889 14.4245 14.648 15.25 16 15.25C17.352 15.25 18.5111 14.4245 19.0009 13.25H21Z\" fill=\"currentColor\"/>\n  <path d=\"M22.25 18C22.25 18.6904 21.6904 19.25 21 19.25H11.0009C10.5111 20.4245 9.35197 21.25 8 21.25C6.64803 21.25 5.48886 20.4245 4.99908 19.25H3C2.30964 19.25 1.75 18.6904 1.75 18C1.75 17.3096 2.30964 16.75 3 16.75H4.99908C5.48886 15.5755 6.64802 14.75 8 14.75C9.35198 14.75 10.5111 15.5755 11.0009 16.75L21 16.75C21.6904 16.75 22.25 17.3096 22.25 18Z\" fill=\"currentColor\"/>"
});
export default Icon;